<template>
   <div class="row">
      <div class="col-4">
         <img class="mb-3" width="30" height="35" src="../assets/images/precampania_icon.svg" />
         <span class="consulta-process-dialog-subheader mb-3">Precampaña / Apoyo Ciudadano</span>
         <p class="consulta-process-dialog-text">
            Actividades realizadas por una persona precandidata a un cargo de elección popular dentro de su partido político, así como, por un
            aspirante a una candidatura independiente para la obtención del apoyo de la ciudadanía.
         </p>
      </div>
      <div class="col-4">
         <img class="mb-3" width="30" height="35" src="../assets/images/campania_icon.svg" />
         <span class="consulta-process-dialog-subheader mb-3">Campaña</span>
         <p class="consulta-process-dialog-text">
            Actividades realizadas por las personas candidatas de partidos políticos, coaliciones y de candidaturas independientes.
         </p>
      </div>
      <div class="col-4">
         <img class="mb-3" width="30" height="35" src="../assets/images/ordinario_icon.svg" />
         <span class="consulta-process-dialog-subheader mb-3">Ordinario</span>
         <p class="consulta-process-dialog-text">
            Actividades ordinarias permanentes y correspondientes al gasto específico que realizan los partidos políticos con registro nacional o
            local, durante el periodo comprendido del 1 de enero al 31 de diciembre.
         </p>
      </div>
   </div>
</template>

<script setup>
import { defineProps, onMounted, ref } from "vue";

const show = ref(false);

const props = defineProps({
   processDialog: Boolean,
});

onMounted(() => {
   show.value = props.processDialog;
});
</script>
